import { render, staticRenderFns } from "./Yewuy.vue?vue&type=template&id=1bca22e2&scoped=true&"
import script from "./Yewuy.vue?vue&type=script&lang=js&"
export * from "./Yewuy.vue?vue&type=script&lang=js&"
import style0 from "./Yewuy.vue?vue&type=style&index=0&id=1bca22e2&scoped=true&lang=css&"
import style1 from "./Yewuy.vue?vue&type=style&index=1&id=1bca22e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca22e2",
  null
  
)

export default component.exports